// extracted by mini-css-extract-plugin
export default {"tabContainer":"Tab_tabContainer__zQY-X","tab":"Tab_tab__qLM8k","tabFocused":"Tab_tabFocused__IbiSb"};